/*
 * File: useChuckieSueService.ts
 * Project: papa-bear
 * -----
 * Last Modified: 18 Jan 2022 11:53:13 am
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { CountriesModel } from 'models/CountriesModel';
import { ReduxState } from 'redux/rootReducer';

/* ****************** Interfaces ****************** */
export interface GetWorldsResponseModel {
  data: {
    countries: CountriesModel[];
    id: string;
  }[];
  totalCount: number;
}

/* ****************** Variables ****************** */
const chuckieSueBaseUrl = process.env.REACT_APP_CHUCKIE_SUE_BASE_URL;
const functionsKey = process.env.REACT_APP_API_HOST_KEY_CHUCKIE_SUE;

const baseQuery = fetchBaseQuery({
  baseUrl: chuckieSueBaseUrl,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as ReduxState).app.accessToken;

    if (token) {
      headers.set('authorization', `Bearer ${token}`);
      headers.set('x-functions-key', functionsKey);
      headers.set('Content-Type', 'application/json');
    }

    return headers;
  }
});

export const worldsApi = createApi({
  reducerPath: 'worldsApi',
  baseQuery,
  endpoints: (builder) => ({
    getWorlds: builder.query<GetWorldsResponseModel, void>({
      query: () => ({
        url: 'worlds'
      })
    }),
    getVersion: builder.query<string, void>({
      query: () => ({
        url: '/diagnostics/version',
        responseHandler: (response): Promise<string> => response.text()
      })
    }),
    getApiName: builder.query<string, void>({
      query: () => ({
        url: '/diagnostics/apiName',
        responseHandler: (response): Promise<string> => response.text()
      })
    })
  })
});

export const { useGetWorldsQuery, useGetVersionQuery, useGetApiNameQuery } = worldsApi;
